
// src/connects/group-remind-panel.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'
import { getArray } from '../helpers/store'

export const mapStateToProps = (state, ownProps)=> {
  return {
    group: getArray('group_id', state.groups.items, ownProps.group.group_id),
    isRemindSettingUpdating: state.groups.isRemindSettingUpdating,
    isRemindSettingUpdateFailed: state.groups.isRemindSettingUpdateFailed,
    remindSchedule: state.groups.remindSchedule,
    isMembershipUpdating: state.groups.isMembershipUpdating,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    updateRemindSchedule: (props, item, value)=> {
      dispatch(actions.updateRemindMailSchedule(
        props.group.group_id,
        item == 'send_on_sun' ? value : props.remindSchedule.send_on_sun,
        item == 'send_on_mon' ? value : props.remindSchedule.send_on_mon,
        item == 'send_on_tue' ? value : props.remindSchedule.send_on_tue,
        item == 'send_on_wed' ? value : props.remindSchedule.send_on_wed,
        item == 'send_on_thu' ? value : props.remindSchedule.send_on_thu,
        item == 'send_on_fri' ? value : props.remindSchedule.send_on_fri,
        item == 'send_on_sat' ? value : props.remindSchedule.send_on_sat,
        item == 'send_on_holiday' ? value : props.remindSchedule.send_on_holiday,
        item == 'send_at' ? value : props.remindSchedule.send_at,
        item == 'timezone' ? value : props.remindSchedule.timezone,
      ))
      dispatch(emitAlertMessage('label:リマインド通知の送信スケジュールを変更しました', 'success'))
    },

    cancelAllRemind: (props)=> {
      dispatch(actions.updateRemindMailSchedule(props.group.group_id, 
        false, false, false, false, false, false, false, false,
        props.remindSchedule.send_at, props.remindSchedule.timezone,
      ))
      dispatch(emitAlertMessage('label:リマインド通知の送信スケジュールを変更しました', 'success'))
    },

    willMount: (props)=> dispatch(actions.fetchRemindMailSettings(props.group.group_id)),

    updateRemindMailSetting: (props, user, delivery)=> {
      dispatch(actions.updateRemindMailSetting(props.group.group_id, user.user_id, delivery))
      if (delivery)
        dispatch(emitAlertMessage({ message: 'label:ユーザへのリマインドメールの送信を開始します', name: user.name }, 'success'))
      else
        dispatch(emitAlertMessage({ message: 'label:ユーザへのリマインドメールの送信を停止しました', name: user.name }, 'success'))
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/group-remind-panel.js